<template>
    <div class="ui button no border"
        style="border-right: 1px #252525 solid;"
        :class="{
            loading : eventbus.print_label.is_processing,
        }"
        :style="{
            color : (eventbus.print_label.error) ? 'red' : '',
        }"
        @click="$bus.$emit(eventbus.print_label.name)">
        <span v-if="eventbus.print_label.error">
            <i class="warning sign icon"></i>
            {{ eventbus.print_label.error }}
        </span>
        <span>
            {{ $t('ui.toolbox.core_waybill.btns.'+((eventbus.print_label.is_force) ? 'print_again': 'print')) }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },
    },
    data() {
        return {
            is_processing: true,
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_processing = false
            })
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
